import { toNumber } from 'lodash'

import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { system } from '@eastcoal/common/config/system'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { AuctionMemberPageStatus } from '../../../enums/AuctionMemberPageStatus'

import { AnnouncementNavigateButtonProps } from './interface'

const ANNOUNCEMENT_DETAIL_PAGE_PATH = '/announcement/apply/detail'

export const AnnouncementNavigateButton = ({
  record
}: AnnouncementNavigateButtonProps) => {
  const to = () => {
    const url = system.router.mallBaseUrl + ANNOUNCEMENT_DETAIL_PAGE_PATH
    return stringifyUrl({
      url,
      query: {
        id: record.announcementId
      }
    })
  }

  const status = toNumber(record.status)

  return status < AuctionMemberPageStatus.BIDDING ? (
    <NavigateButton newtab to={to}>
      查看预告
    </NavigateButton>
  ) : null
}
